// Auto-generated from gen_ce_info_and_maps.ts
// DO NOT EDIT THIS FILE DIRECTLY

import { CEMap } from '../types/ce';

import SouthHornCEs from './south_horn_encounters';

const data: CEMap<typeof SouthHornCEs> = {
  '320': 'ScourgeOfTheMind',
  '322': 'TheBlackRegiment',
  '323': 'FromTimesBygone',
  '327': 'NoiseComplaint',
  '329': 'EternalWatch',
  '330': 'CrawlingDeath',
  '338': 'OnTheHunt',
  '339': 'WithExtremePrejudice',
  '343': 'CompanyOfStone',
  '348': 'TheUnbridled',
  '349': 'TrialByClaw',
  '32A': 'FlameOfDusk',
  '32B': 'CursedConcern',
  '32E': 'SharkAttack',
  '32F': 'CalamityBound',
  '33B': 'TheForkedTowerBlood',
} as const;

export default data;
